import { Directive, Input, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[gfClipboard]'
})
export class GfClipboardDirective {

  @Input('gfClipboard') textToCopy: string;
  @Output() onCopy: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  @HostListener('click', ['$event'])
  copyText(event: Event): void {
    event.preventDefault();

    const textarea = document.createElement('textarea');
    textarea.value = this.textToCopy || '';
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';

    document.body.appendChild(textarea);
    textarea.select();

    let successful = false;
    try {
      successful = document.execCommand('copy');
    } catch (err) {
      console.error('Error copying text:', err);
    }

    document.body.removeChild(textarea);
    this.onCopy.emit(successful);
  }
}
